import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthDispatch } from "../../context/authContext";
import { login, user_routes } from "../../services/user/UserService";
import jwtDecode from "jwt-decode";
import { Alert, Box, CircularProgress, Container, Typography } from "@mui/material";
import { useQuery } from "react-query";
import { SC_KEY } from "../../utils/constants/Constant_API";
import { IAlert, InitialAlert } from "../../types/AlertTypes";
const CryptoJS = require("crypto-js");

interface DecodedToken {
    exp: number;
    // Otras propiedades que esperas en tu token decodificado
}

const Login = () => {
    const logoEducem = "https://resoures-educem.s3.us-west-2.amazonaws.com/Logos/Educem/500500cb.png";
    const authDispatch = useAuthDispatch();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [disabledRouter, setDisabledRouter] = useState(true);
    const [alert, setAlert] = useState<IAlert>(InitialAlert)
    const svgRef = useRef<SVGSVGElement | null>(null);

    const [errorResponse, setErrorResponse] = useState(null);
    useEffect(() => {
        const initLogin = async () => {
            try {
                if (!searchParams?.get('id')) {
                    setAlert(prevState => ({ ...prevState, message: "Sin ID", severity: "error" }))
                    // navigate("https://sam.educem.mx");
                    window.location.href = "https://sam.educem.mx";
                } else {
                    const id = searchParams.get('id');
                    if (id) {
                        const decoded: DecodedToken = jwtDecode(id);
                        const currentTime = Math.floor(Date.now() / 1000);

                        if (decoded.exp && decoded.exp < currentTime) {
                            console.log("Token expirado");
                        } else {
                            const data = await login(id.toString());
                            if (data != null) {
                                console.log("La petición fue exitosa");
                                const token = id;
                                authDispatch({
                                    type: "login",
                                    token
                                });
                            }
                        }
                    } else {
                        console.log("ID no encontrado");
                        // navigate("https://sam.educem.mx");
                        window.location.href = "https://sam.educem.mx";
                    }
                }
            } catch (error) {
                console.error("Error en el proceso de inicio de sesión:", error);
            }
        };

        initLogin();
    }, [searchParams, authDispatch, navigate]);

    const { isLoading, isError } = useQuery(["userRoutes"], () => user_routes(), {
        enabled: disabledRouter,
        onSuccess: (data) => {
            setDisabledRouter(false);
            const dataMS_encrypt = CryptoJS.AES.encrypt(JSON.stringify(data.data), SC_KEY).toString();
            localStorage.setItem('React.LC.KY.MS', dataMS_encrypt);
            navigate("/");
        },
        onError: (error: any) => {
            setDisabledRouter(false);
            setErrorResponse(error.response.data.message);
        },
    });

    useEffect(() => {
        setTimeout(() => {
            if (svgRef.current) {
                svgRef.current.classList.add('animated');
            }
        }, 500);
    }, []);

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <img src={logoEducem} alt="Logo" width={150} style={{ margin: 5 }} />
                <Typography component="h6" variant="h6" sx={{ fontWeight: 'bold', color: "#233878", mb: 1 }}>
                    CMS-MENAH, Comprobando tu identidad.
                </Typography>

                {isError && <Alert severity="error">{errorResponse}</Alert>}
                <br />
                {isLoading && <CircularProgress />}
            </Box>
        </Container>
    );
};

export default Login;
